import React, { createContext, useState } from "react";

export const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [taskTypeTab, setTaskTypeTab] = useState(0);
  const [bottomBarTab, setBottomBarTab] = useState(0);
  const [apiMode, setApiMode] = useState("local");

  const getEndpointUrl = () => {
    return apiMode === "server"
      ? "https://api.anothertask.app"
      : "http://192.168.1.30:8080";
  };

  const selectTaskTypeTab = (tabIndex) => {
    setTaskTypeTab(tabIndex);
  };

  const selectBottomBarTab = (tabIndex) => {
    setBottomBarTab(tabIndex);
  };

  return (
    <SessionContext.Provider
      value={{
        taskTypeTab,
        selectTaskTypeTab,
        bottomBarTab,
        selectBottomBarTab,
        apiMode,
        setApiMode,
        getEndpointUrl,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
